module.exports = __webpack_public_path__ + "img/navigation.b7c9a04d.svg";